import { httpRequest } from '@calendly/http-tools'

import { setGeneralError } from './errors'

const setCalendarAccounts = (responseData) => ({
  type: 'SET_CALENDAR_ACCOUNTS',
  payload: { accounts: responseData }
})

async function doFetchAccounts(dispatch, _) {
  const [success, responseData] = await httpRequest({
    url: '/api/booking/calendar_accounts?with_calendars=1',
    type: 'GET'
  })

  if (success) {
    dispatch(setCalendarAccounts(responseData))
  } else {
    dispatch(setGeneralError(responseData))
  }
}

export const fetchAccounts = () => (dispatch, getState) => doFetchAccounts(dispatch, getState())
